import { render, staticRenderFns } from "./Milestones.vue?vue&type=template&id=45422f5d&scoped=true"
import script from "./Milestones.vue?vue&type=script&lang=js"
export * from "./Milestones.vue?vue&type=script&lang=js"
import style0 from "./Milestones.vue?vue&type=style&index=0&id=45422f5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45422f5d",
  null
  
)

export default component.exports